export enum CarbucksVehicleEventType {
    Engine = 0,
    Battery = 1,
    OilLevelCheck = 2,
    Recall = 3,
    ServiceCompleted = 4,
    TyresReplaced = 5,
    TyrePressureChecked = 6,
    TyreRotation = 7,
    CarWashed = 8,
    VehicleAdded = 9,
    RegoRenewed = 10,
    WindscreenRepair = 11,
    WheelAlignment  = 12
}

export const CarbucksVehicleEventTypeDescriptions = new Map<CarbucksVehicleEventType, string>([
    [CarbucksVehicleEventType.Engine, "Issue resolved"],
    [CarbucksVehicleEventType.Battery, "Battery replacement"],
    [CarbucksVehicleEventType.OilLevelCheck, "Oil level check"],
    [CarbucksVehicleEventType.Recall, "Recall"],
    [CarbucksVehicleEventType.ServiceCompleted, "Service completed"],
    [CarbucksVehicleEventType.TyresReplaced, "Tyre replacement"],
    [CarbucksVehicleEventType.TyrePressureChecked, "Tyre pressure check"],
    [CarbucksVehicleEventType.TyreRotation, "Tyre rotation"],
    [CarbucksVehicleEventType.CarWashed, "Car washed"],
    [CarbucksVehicleEventType.VehicleAdded, "Vehicle added"],
    [CarbucksVehicleEventType.RegoRenewed, "Rego renewed"],
    [CarbucksVehicleEventType.WindscreenRepair, "Windscreen repair"],
    [CarbucksVehicleEventType.WheelAlignment, "Wheel alignment"],
]);